import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import {globalfunc} from '../globalfunc.js';
import countriesAndTimezone from 'countries-and-timezones';
import reward from './reward.js';
import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import subHours from 'date-fns/sub_hours';
const apiUrl='https://api-node.happily.ai'
import { getCompany } from './core/cacheService'
class Convert {
  time: any;
  constructor (message: any) {
      this.time = message;
  }
  convertTime() : any {
    let timeC = this.time;
    let hours = Number(timeC.match(/^(\d+)/)[1]);
    let minutes = Number(timeC.match(/:(\d+)/)[1]);
    let AMPM = timeC.match(/\s(.*)$/)[1];
    console.log("AMPM",AMPM)
    console.log("minutes",minutes)
    console.log("hours",hours)

    if(AMPM == "PM" && hours<12) hours = hours+12;
    if(AMPM == "AM" && hours==12) hours = hours-12;
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if(hours<10) sHours = "0" + sHours;
    if(minutes<10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes;
  }
} 
export default {
    namespaced: true,
    state: {
        timeZoneOption:[],
        locationOption:[],
        timezone:[],
        rewardMaster:[]
    },
    mutations: {
        setTimeZoneOption(state:any, result:any) {
            state.timeZoneOption = result
          },
          setTimezone(state:any, result:any) {
            state.timezone = result
          },
          setLocationOption(state:any, result:any) {
            state.locationOption = result
          },
          setRewardMaster(state:any, result:any) {
            state.rewardMaster = result
          },
    },
    actions: {
    /**
     * Legacy `/freetrial` POST used by `register.vue` / `setup-wizard.vue`.
     *
     * The new self-serve free-tier signup flow does NOT call this action.
     * It calls `registerFreetrial` in `src/store/core/cacheService.ts`
     * with the extended payload (plan_tier, brand_color, brand_logo_url,
     * hashtag map, onboarding_completed, flat core_values list, flat
     * `people` array, selected_reward_ids, admin block) and dispatches
     * `signup/submitSignup` from the wizard's review step.
     *
     * Phase D Track D2 — payload shape updated: the company block now
     * carries `cadence` + `delivery_time` from Step 1 (HQ `address`
     * dropped) and the legacy nested `teams[]` is replaced by a flat
     * `people[]`. Callers that still dispatch this action should pass
     * `value.cadence`, `value.delivery_time`, and `value.people` (or a
     * derived people list) — anything missing falls back to the
     * documented defaults.
     *
     * This action is retained so existing flows keep working during the
     * rollout; remove once all entry points are migrated.
     */
    async register({ commit, rootState, state, dispatch }: any, value: any){

        var data: any = {
            name:value.companyName,
            reward_note: "",
            reward_note_th: "",
            billing_currency: "THB",
            rate: 0,
            country:value.country || value.location || "",
            email_type:"html",
            gen_question: "Y",
            starttime: value.delivery_time || "08:00",
            starttime_show: value.delivery_time || "08:00",
            starttime_timezone: value.delivery_time || "08:00",
            cadence: value.cadence || "balanced",
            delivery_time: value.delivery_time || "08:00",
            reminder:"Y",
            reminder_time:"18.00",
            report_dailyboss:"Y",
            report_dailyboss_time:"08.30",
            report_weeklyboss:"Y",
            report_weeklyboss_time:"08.30",
            report_weeklyuser:"Y",
            report_weeklyuser_time:"08.15",
            coaching:"Y",
            coaching_time:"10:30",
            report_monthlyboss:"N",
            report_activity_manager:"N",
            qrcode:"Y",
            leadership:"Y",
            create_sessions:"Y",
            spark :'Y',
            house_village :'Y',
            create_topics : 'Y',
            townhall :'Y',
            peer_feedback : 'Y',
            huddles:'N',
            feedback_to_leader :'N',
            show_integration :'N',
            birthday :'Y',
            assist_access:'false',
            recharge_powerup : 'Y',
            follow_message : 'Y',
            ai_reply : 'Y',
            timezone:
                typeof value.timezone === 'number'
                    ? value.timezone
                    : (state.timezone && state.timezone[value.timeZone]
                        ? parseInt(state.timezone[value.timeZone].utcOffsetStr)
                        : 0),
            updated:  format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            feed_logo:'',
            village_logo:'',
            balloon_logo:'',
            status:"Y",
            rewards_manage:"happily"
        }

        //let newId:any = firebase.database().ref('company').push().key;
        
        // let insert = {};
        // insert[newId] = data;
        // console.log("insert",insert)
       // await firebase.database().ref('company').update(insert);
        
        // let name=value.name.split(" ")


        // let dataUser={
        //     country:value.location,
        //     email:value.email,
        //     language:value.language,
        //     firstname:name[0].trim(),
        //     lastname:name[1].trim(),
        //     company:newId,
        //     team:"",
        //     boss:"",
        //     user_type:"superadmin",
        //     gem:0,
        //     coin:0,
        //     powerup:{
        //       fivecoins:14,
        //       threecoins:7,
        //     },
        //     profilepic:"",
        //     address:"",
        //     mobile:"",
        //     phone:"",
        //     updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
        //     createdatetime:format(new Date(), 'YYYY-MM-DD HH:mm'),
        //     modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
        // }
        // let insertUser = {};
        // let emailKey=value.email.replace(/\./g, "||");
        // insertUser[emailKey] = dataUser;
        // console.log("emailKey",insertUser[emailKey])
       // await firebase.database().ref('users').update(insertUser);
       // dispatch("auth/login", {email: value.email});

       var axios = require('axios');
       var url=""
       var optionData:Array<any> = [];
       let currentDate= format(new Date(), 'YYYY')
       
       // Phase D Track D2 — strip the legacy `location`/`teams` shape
       // from the spread so we don't double-send conflicting fields,
       // and ensure the modern `people[]` lands at the top level if
       // the caller provided it. Anything else on `value` (email,
       // language, etc.) is preserved verbatim.
       const { location: _legacyLocation, teams: _legacyTeams, ...rest } = (value as any) || {}
       var config = {
         method: 'POST',
         url: apiUrl+`/freetrial`,
         headers: {
           'Access-Control-Allow-Origin': '*',
           'Access-Control-Allow-Credentials': 'true',
           'Access-Control-Allow-Headers': 'Content-Type, Authorization',
           'Access-Control-Allow-Methods' : 'GET, POST, OPTIONS',
         },
         data: {
          company: data,
          ...rest,
          people: Array.isArray(value && value.people) ? value.people : [],
          // email:value.email,
          // name:value.name
        },
       };
       
       axios(config)
       .then(function (response) {
         const data = response.data

         console.log("data",data)

         dispatch("auth/login", {email: value.email,freetrial:true}, {root:true});
       })
       .catch(function (error) {
         console.log(error);
       });


    },
    getTimezone({ commit, rootState, state, dispatch }: any, value: any){
        let timezone=countriesAndTimezone.getAllTimezones()
        let countries=countriesAndTimezone.getAllCountries()
        let optionsTimezone:Array<any>=[]
        let locationOption:Array<any>=[]
        for(let value in timezone){
            optionsTimezone.push( { lable: value,value: value})
        }
        for(let value in countries){
            locationOption.push( { lable: value,value: countries[value].name})
        }
        locationOption=_.sortBy(locationOption, [
            function(o) {
              return o.value;
            }
          ]);
          optionsTimezone=_.sortBy(optionsTimezone, [
            function(o) {
              return o.value;
            }
          ]);
        commit('setTimeZoneOption',optionsTimezone)
        commit('setLocationOption',locationOption)
        commit('setTimezone',timezone)
       
    },
    /**
     * @deprecated LEGACY client-side write path — fires parallel
     * Firebase RTDB updates for the new superadmin/manager/members,
     * rewards_company (copies ALL global rewards), and company hashtag.
     * This is the split-state race path flagged in the plan
     * (`setup-wizard.vue:693–700` dispatches three of these in parallel
     * with no ordering or error handling).
     *
     * The new self-serve flow replaces this with a single atomic
     * backend write via `POST /freetrial` (see `registerFreetrial` in
     * `src/store/core/cacheService.ts`). Kept here as a compatibility
     * shim for existing callers (e.g. `setup-wizard.vue`) during the
     * rollout — Track B3 may still dispatch it until the atomic
     * backend is fully live. Delete once every caller is migrated and
     * the backend endpoint is confirmed stable in production.
     *
     * TODO(free-tier-signup): remove this action and its caller in
     * `setup-wizard.vue` once `/freetrial` atomic provisioning is live.
     */
    async registerMember({ commit, rootState, state, dispatch }: any, value: any){
        console.log("value",value)
        console.log("rootState.authen.user",rootState.authen.user)
        let insertUser = {};
        let rewards_company={}
        const dateNow = new Date()
       
        const companyData = await getCompany(rootState.authen.user.company)
        if(rootState.authen.user.email){
          let email_Key=rootState.authen.user.email.replace(/\./g, "||");
          var userData = rootState.main.allUser[email_Key]//(await firebase.database().ref(`/users/${email_Key}`).once('value')).val()
        }
        //manager
        let name=value.manager.managerName.split(" ")
        const managerEmail = (value.manager.emailManager || '').toLowerCase().replace(/\s+/g, '')
        let dataUser={
         country:userData.country,
         email:managerEmail,
         language:userData.language,
         firstname:name[0].trim(),
         lastname:name[1].trim(),
         company:rootState.authen.user.company,
         team:"",
         boss:"",
         user_type:"superleader",
         gem:0,
         coin:0,
         powerup:{
           fivecoins:14,
           threecoins:7,
         },
         profilepic:"",
         address:"",
         mobile:"",
         phone:"",
         updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
         createdatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
         modifydatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
     }
 
        
     
     let emailKey=managerEmail.replace(/\./g, "||");
     insertUser[emailKey] = dataUser;


        value.members.map(v=>{
          console.log("v",v)
        if(v.name){
          let name=v.name.split(" ")
          const memberEmail = (v.email || '').toLowerCase().replace(/\s+/g, '')
          let dataUser={
           country:userData.country,
           email:memberEmail,
           language:userData.language,
           firstname:name[0].trim(),
           lastname:name[1].trim(),
           company:rootState.authen.user.company,
           team:"",
           boss:"",
           user_type:"superadmin",
           gem:0,
           coin:0,
           powerup:{
             fivecoins:14,
             threecoins:7,
           },
           profilepic:"",
           address:"",
           mobile:"",
           phone:"",
           updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
           createdatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
           modifydatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
       }
   
          
       
       let emailKey=memberEmail.replace(/\./g, "||");
       insertUser[emailKey] = dataUser;

      }})
         
         firebase.database().ref('users').update(insertUser);
         /*save logs - track which screen created the user */
         const actorEmail = rootState.authen.user.email
         const userCompany = rootState.authen.user.company
         Object.keys(insertUser).forEach((createdKey) => {
           dispatch('authen/addLogs', {
             company: userCompany,
             createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
             id: createdKey,
             table: 'users',
             status: 'add',
             source: 'setup_wizard',
             user: actorEmail,
           }, { root: true })
         })
         rewards_company[`rewards_company/${rootState.authen.user.company}`] =state.rewardMaster
         console.log("rewards_company",rewards_company)
         firebase.database().ref().update(rewards_company);

         let coreValue={}
         let starttime=''
         let starttime_timezone = ''

         for(var i in value.recognitionValue){
          let _id=firebase.database().ref(`company/${rootState.authen.user.company}/hashtag`).push().key;
          if(_id) 
          coreValue[_id]={
             name:value.recognitionValue[i].label,
             name_th:value.recognitionValue[i].label,
           }
         }
         if(companyData.timezone){

         const setlengthTimezone = [];
         setlengthTimezone['7'] = [4, 4.5, 5, 5.5, 5.75, 6, 6.5, 7, 8, 9, 9.5, 10];
         setlengthTimezone['-7'] = [-4, -5, -6, -7, -8, -9, -10];
         setlengthTimezone['0'] = [-3.5, -3, -2, -1, 0, 1, 2, 3, 3.5];
         let globalTime = 0
         if (setlengthTimezone['7'].indexOf( parseFloat(companyData.timezone)) !== -1)
             globalTime = 7;
         if (setlengthTimezone['-7'].indexOf( parseFloat(companyData.timezone)) !== -1)
             globalTime = -7;
         if (setlengthTimezone['0'].indexOf( parseFloat(companyData.timezone)) !== -1)
         globalTime = 0;

         let diffTimezone = companyData.timezone - globalTime
         let convert_1 = new Convert(value.gen_question);
         let starttimeSave = convert_1.convertTime();
          const DailyPulse:any = starttimeSave.split(":")
          const starttimeTimezone = starttimeSave.split(":");
         starttime = format(subHours(dateNow.setHours(DailyPulse[0], DailyPulse[1]),diffTimezone), 'HH:mm')     
         starttime_timezone = format(dateNow.setHours(starttimeTimezone[0], starttimeTimezone[1]), 'HH:mm')
        }
         let updateCompany={
          hashtag_status:true,
          hashtag:coreValue,
          starttime:starttime,
          starttime_show:starttime,
          starttime_timezone:starttime_timezone
         }
          console.log("updateCompany",updateCompany)
         firebase.database().ref(`company/${rootState.authen.user.company}`).update(updateCompany);




    },
    async rewardMaster({ commit, rootState, state, dispatch }: any, value: any){
      let companyReward={}
      firebase.database().ref('rewards').orderByChild("company").equalTo('global').once('value', snapshot => {
        snapshot.forEach((arrData) => {
          const _data = arrData.val()
          if(_data.newtype=="Company Reward" && _data.status=="Y"){
              _data.status="Y"
              _data.show="Y"
              
              if(arrData.key){companyReward[arrData.key]=_data}
          }
        })
        commit('setRewardMaster',companyReward)
        
    })
    },
    /**
     * @deprecated LEGACY client-side write path — pushes pending
     * `user_invite` RTDB records for the manager + members. The new
     * self-serve signup flow folds this into the atomic
     * `POST /freetrial` call (backend queues the invite emails
     * server-side), so the client no longer needs to write
     * `user_invite` directly.
     *
     * Retained as a compatibility shim for existing callers
     * (`setup-wizard.vue`) during the rollout. Remove once every
     * caller is migrated to `signup/submitSignup`.
     *
     * TODO(free-tier-signup): delete once the atomic backend
     * provisioning path is the only signup entry point.
     */
    async inviteMember({ commit, rootState, state, dispatch }: any, value: any){
      let insert = {};
      const managerEmail = (value.manager.emailManager || '').toLowerCase().replace(/\s+/g, '')
      if(managerEmail!=rootState.authen.user.email){
        
        const newId = firebase.database().ref().child('user_invite').push().key;     
        const data = {
          email:managerEmail
      };
        if(newId){
          insert[newId] = data;
        }

      }
      value.members.map(v=>{
       // console.log("v",v)
      if(v.name){
        const memberEmail = (v.email || '').toLowerCase().replace(/\s+/g, '')
        if(memberEmail!=rootState.authen.user.email){

          const newId = firebase.database().ref().child('user_invite').push().key;     
          const data = {
            email: memberEmail
        };
        if(newId){
          insert[newId] = data;
        }
      }
      }})
      firebase.database().ref('user_invite').update(insert);
    }

    
  },
    getters: {
        timeZoneOption : (state:any) => {
            return state.timeZoneOption
          },
          locationOption : (state:any) => {
            return state.locationOption
          },
    }
}